import React from "react";
import { motion } from "framer-motion";
import { UserCheck, FileText, CheckCircle, Hammer, Home } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: UserCheck,
    title: "Meet Our Designer",
    description: "Talk to our design experts and turn your dreams into a reality.",
  },
  {
    number: "02",
    icon: FileText,
    title: "Get Free Estimate",
    description: "Once your dreams have been pieced together, get a cost estimate.",
  },
  {
    number: "03",
    icon: CheckCircle,
    title: "Design Sign-off",
    description: "As soon as you okay the estimate and design, execution begins.",
  },
  {
    number: "04",
    icon: Hammer,
    title: "Installation",
    description: "The team arrives on-site and oversees the installation process.",
  },
  {
    number: "05",
    icon: Home,
    title: "Move-in Ready",
    description: "Your dream home ready in 45-90 working days.",
  },
];

export const ProcessSection = () => {
  return (
    <section id="process" className="section bg-[hsl(var(--brand-emerald))] text-white relative overflow-hidden">
      <div className="noise-overlay"></div>
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-[hsl(var(--brand-champagne))]/70 mb-4">
            Our Process
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-[hsl(var(--brand-champagne))]">
            A Seamless 5-Step Process
          </h2>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto">
            From initial consultation to final installation, we ensure a smooth
            journey to your dream home.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-testid="process-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`process-step-${index + 1}`}
                className="relative"
              >
                <div className="glass-card p-6 rounded-xl h-full flex flex-col">
                  <div className="text-[hsl(var(--brand-gold))] text-4xl font-display font-bold mb-4">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 rounded-full bg-[hsl(var(--brand-gold))]/20 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-[hsl(var(--brand-gold))]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif-alt text-lg font-semibold mb-2 text-[hsl(var(--brand-champagne))]">
                    {step.title}
                  </h3>
                  <p className="text-sm text-white/70 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                {/* Connector Line - Desktop Only */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 left-full h-px w-6 bg-[hsl(var(--brand-gold))]/40 -translate-y-1/2"></div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
